import { supabase } from '../lib/supabaseClient';

//
// 🧠 USER PROFILES
//
export const getUserProfile = async (userId) => {
    const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', userId)
        .maybeSingle();

    if (error) throw error;
    return data;
};
/*
export const getOrCreateUserProfile = async (user) => {
    if (!user) return null;

    try {
        const profile = await getUserProfile(user.id);

        if (profile) return profile;

        // Si no existe, lo creamos
        return await createUserProfile(user);
    } catch (error) {
        console.error('❌ Error en getOrCreateUserProfile:', error.message);
        return null;
    }
};*/

// dbService.js - createUserProfile
/*
export const createUserProfile = async (user) => {
    console.log("Attempting to create profile for user ID:", user?.id);
    console.log("User object passed to createUserProfile:", JSON.stringify(user, null, 2));

    // Para ver qué token está usando el cliente Supabase en este momento (esto es más avanzado y puede no ser fácil de obtener directamente)
    // Pero podemos verificar si hay una sesión activa desde la perspectiva del cliente
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError) console.error("Error getting session within createUserProfile:", sessionError.message);
    console.log("Session state within createUserProfile (before insert):", session ? session.user?.id : "No session");

    const { data, error } = await supabase
        .from('profiles')
        .insert([{
            id: user.id,
            email: user.email,
            full_name: user.user_metadata?.full_name || 'User',
            avatar_url: user.user_metadata?.avatar_url || '',
            is_admin: false,
            suscription_plan: 0,
            created_at: new Date().toISOString()
        }])
        .select()
        .single();

    if (error) throw error;
    return data;
};*/

export const updateUserProfile = async (userId, updates) => {
    const { data, error } = await supabase
        .from('profiles')
        .update(updates)
        .eq('id', userId)
        .select()
        .single();

    if (error) throw error;
    return data;
};

export const deleteUserProfile = async (userId) => {
    const { error } = await supabase
        .from('profiles')
        .delete()
        .eq('id', userId);

    if (error) throw error;
};

//
// 🎯 GOALS
//

export const addGoal = async (userId, goal) => {
    const { error } = await supabase.from('goals').insert({
        user_id: userId,
        target: goal.target,
        deadline: goal.deadline || null,
    });

    if (error) throw error;
};

export const getGoals = async (userId) => {
    const { data, error } = await supabase
        .from('goals')
        .select('*')
        .eq('user_id', userId);

    if (error) throw error;
    return data;
};

export const updateGoals = async (userId, goals) => {
    console.log('updating goals: ' + goals);
    // Limpiamos los objetivos actuales
    await supabase.from('goals').delete().eq('user_id', userId);

    const inserts = goals.map(goal => ({
        user_id: userId,
        target: goal.target,  // nuevo campo
        deadline: goal.deadline,  // nuevo campo
    }));

    const { error } = await supabase.from('goals').insert(inserts);

    if (error) throw error;
};

export const deleteGoal = async (goalId) => {
    const { error } = await supabase
        .from('goals')
        .delete()
        .eq('id', goalId);

    if (error) throw error;
};

//
// 🚫 RESTRICTIONS
//
export const getRestrictions = async (userId) => {
    const { data, error } = await supabase
        .from('restrictions')
        .select('*')
        .eq('user_id', userId);

    if (error) throw error;
    return data;
};

export const updateRestrictions = async (userId, restrictions) => {
    console.log('updating restrictions: ' + restrictions);
    // Eliminamos las restricciones anteriores
    await supabase.from('restrictions').delete().eq('user_id', userId);

    const inserts = restrictions.map(r => ({ user_id: userId, restriction: r }));
    const { error } = await supabase.from('restrictions').insert(inserts);

    if (error) throw error;
};

export const deleteRestriction = async (restrictionId) => {
    const { error } = await supabase
        .from('restrictions')
        .delete()
        .eq('id', restrictionId);

    if (error) throw error;
};

//
// 📸 USER ACTIVITY
//
export const getUserActivity = async (userId) => {
    const { data, error } = await supabase
        .from('user_activity')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
};


/**
 * Deletes a specific user activity by its ID.
 * @param {string} activityId - The ID of the activity record to delete.
 * @param {string} userId - The ID of the user (for ownership verification if needed).
 * @returns {Promise<boolean>} - True if deletion was successful, false otherwise.
 */
export const hideUserActivity = async (activityId, userId) => {
    if (!activityId || !userId) {
        console.error("Activity ID and User ID are required to hide activity.");
        return false;
    }

    try {
        // Verificar que la actividad pertenezca al usuario
        const { data: activity, error: fetchError } = await supabase
            .from('user_activity')
            .select('user_id')
            .eq('id', activityId)
            .single();

        if (fetchError || !activity) {
            console.error('Error fetching activity or activity not found:', fetchError);
            return false;
        }

        if (activity.user_id !== userId) {
            console.warn('User does not own this activity. Operation denied.');
            return false;
        }

        // Actualizar la propiedad "saved" a false
        const { error: updateError } = await supabase
            .from('user_activity')
            .update({ visible: false })  // O usa "visible: false" si prefieres otro nombre
            .eq('id', activityId);

        if (updateError) {
            console.error('Error updating activity visibility:', updateError);
            return false;
        }

        console.log('Activity marked as hidden successfully:', activityId);
        return true;
    } catch (err) {
        console.error("Unexpected error in hideUserActivity:", err);
        return false;
    }
};



/**
 * Make Visible a specific user activity by its ID.
 * @param {string} activityId - The ID of the activity record to delete.
 * @param {string} userId - The ID of the user (for ownership verification if needed).
 * @returns {Promise<boolean>} - True if deletion was successful, false otherwise.
 */
export const visibleUserActivity = async (activityId, userId) => {
    if (!activityId || !userId) {
        console.error("Activity ID and User ID are required to show activity.");
        return false;
    }

    try {
        // Verificar que la actividad pertenezca al usuario
        const { data: activity, error: fetchError } = await supabase
            .from('user_activity')
            .select('user_id')
            .eq('id', activityId)
            .single();

        if (fetchError || !activity) {
            console.error('Error fetching activity or activity not found:', fetchError);
            return false;
        }

        if (activity.user_id !== userId) {
            console.warn('User does not own this activity. Operation denied.');
            return false;
        }

        // Actualizar la propiedad "saved" a false
        const { error: updateError } = await supabase
            .from('user_activity')
            .update({ visible: true })  // O usa "visible: true" si prefieres otro nombre
            .eq('id', activityId);

        if (updateError) {
            console.error('Error updating activity visibility:', updateError);
            return false;
        }

        console.log('Activity marked as shown successfully:', activityId);
        return true;
    } catch (err) {
        console.error("Unexpected error in visibleUserActivity:", err);
        return false;
    }
};


/**
 * Fetches the recipe generation history for a user.
 * @param {string} userId - The ID of the user.
 * @param {number} [limit=20] - Max number of history items to fetch.
 * @returns {Promise<Array<object>>} - An array of recipe history items (likely the activity_data.recipe part).
 */
export const getRecipeHistory = async (userId, limit = 20) => {
    if (!userId) return []; // Return empty if no user ID

    try {
        const { data, error } = await supabase
            .from('user_activity') // Your activities table
            .select('*') // Select relevant columns
            .eq('user_id', userId)
            .eq('visible', true) // Only fetch visible activities
            .eq('activity_type', 'recipe_generated') // Filter by recipe type
            .order('created_at', { ascending: false }) // Newest first
            .limit(limit);

        if (error) {
            console.error('Error fetching recipe history:', error);
            throw error;
        }

        // Extract the actual recipe data and add timestamp/id
        console.log('Fetched recipe history:', data);
        return (data || []).map(activity => ({
            id: activity.id, // Include the activity ID if needed later
            timestamp: activity.created_at,
            ...activity.result.recipe // Extract the recipe object stored in activity_data
        }));

    } catch (err) {
        console.error("Unexpected error fetching recipe history:", err);
        return []; // Return empty array on error
    }
};



/**
 * Fetches the recipe generation history for a user.
 * @param {string} userId - The ID of the user.
 * @param {number} [limit=20] - Max number of history items to fetch.
 * @returns {Promise<Array<object>>} - An array of recipe history items (likely the activity_data.recipe part).
 */
export const getScanHistory = async (userId, limit = 20) => {
    if (!userId) return []; // Return empty if no user ID

    try {
        const { data, error } = await supabase
            .from('user_activity') // Your activities table
            .select('*') // Select relevant columns
            .eq('user_id', userId)
            .eq('visible', true) // Only fetch visible activities
            .in('activity_type', ['barcode_scan', 'image_scan']) // Filtra ambos tipos
            .order('created_at', { ascending: false }) // Newest first
            .limit(limit);

        //console.log('Fetched scan history:', data);

        if (error) {
            console.error('Error fetching recipe history:', error);
            throw error;
        }
        // Extract the actual scan data and add timestamp/id
        return (data || []).map(activity => ({
            id: activity.id, // Include the activity ID if needed later
            timestamp: activity.created_at,
            activity_type: activity.activity_type,
            ...activity // Extract the recipe object stored in activity_data
        }));

    } catch (err) {
        console.error("Unexpected error fetching recipe history:", err);
        return []; // Return empty array on error
    }
};


/**
 * Fetches the workout plan generation history for a user.
 * @param {string} userId - The ID of the user.
 * @param {number} [limit=20] - Max number of history items to fetch.
 * @returns {Promise<Array<object>>} - An array of workout plan history items.
 */
export const getWorkoutHistory = async (userId, limit = 20) => {
    if (!userId) return [];
    try {
        const { data, error } = await supabase
            .from('user_activity') // Assuming 'user_activity' table
            .select('*') // Select necessary columns
            .eq('user_id', userId)
            .eq('activity_type', 'workout_generated') // Filter by workout type
            .eq('visible', true) // Assuming you only want visible items in history
            .order('created_at', { ascending: false })
            .limit(limit);


        if (error) {
            console.error('Error fetching workout history:', error);
            throw error;
        }
        // Assuming 'result' column contains { workout: workoutPlanObject }
        return (data || []).map(activity => ({
            id: activity.id,
            timestamp: activity.created_at,
            activity_type: activity.activity_type, // Good to have for ItemDetailsModal title
            // The actual workout plan is expected to be nested under 'workout' in the 'result' column
            // based on how onWorkoutGenerated was structured in MainPage.js
            workoutPlan: activity.result?.workout || activity.result, // Access nested plan or direct result
            // Add a name or summary if the AI provides one, or generate one
            name: activity.result?.workout?.summary || `Workout Plan - ${new Date(activity.created_at).toLocaleDateString()}`
        }));
    } catch (err) {
        console.error("Unexpected error fetching workout history:", err);
        return [];
    }
};



/**
 * Fetches the weekly menu generation history for a user.
 * @param {string} userId - The ID of the user.
 * @param {number} [limit=10] - Max number of history items to fetch.
 * @returns {Promise<Array<object>>} - An array of menu history items.
 */
export const getMenuHistory = async (userId, limit = 10) => {
    if (!userId) return [];
    try {
        const { data, error } = await supabase
            .from('user_activity') // Your activities table
            .select('*') // Select necessary columns
            .eq('user_id', userId)
            .eq('activity_type', 'menu_generated') // Filter by menu type
            .eq('visible', true) // Assuming you only want visible items
            .order('created_at', { ascending: false })
            .limit(limit);

        //console.log('Fetched menu history:', data); // Log the fetched data for debugging
        if (error) {
            console.error('Error fetching menu history:', error);
            throw error;
        }
        // Assuming 'result' column contains { menu: menuObject }
        return (data || []).map(activity => ({
            id: activity.id,
            timestamp: activity.created_at,
            activity_type: activity.activity_type,
            // The actual menu plan is expected to be nested under 'menu' in the 'result' column
            menu: activity.result?.menu || activity.result, // Access nested menu or direct result
            // Generate a simple name/summary for display in history list
            name: `Weekly Menu - ${new Date(activity.created_at).toLocaleDateString()}`,
            // You could try to extract numDays or dietPreference if stored in result.menu
            summary: `For ${activity.result?.menu?.numPeople || activity.result?.numPeople || 'N/A'} people, ${Object.keys(activity.result?.menu || activity.result || {}).filter(k => k.startsWith('day')).length || 'N/A'} days`
        }));
    } catch (err) {
        console.error("Unexpected error fetching menu history:", err);
        return [];
    }
};

/**
 * Saves a user activity to the user_activity table.
 * @param {string} userId - The ID of the user.
 * @param {string} activityType - The type of activity (e.g., 'recipe_generated', 'scan_barcode').
 * @param {object} resultData - The data payload for the activity (e.g., the recipe object, scan data).
 *                             This should be the object that will be stored in the 'result' JSONB column.
 * @param {boolean} [initiallyVisible=true] - Whether the activity should be visible by default.
 * @returns {Promise<object|null>} - The saved activity object (including its ID and other columns) or null on error.
 */
export const saveUserActivity = async (userId, activityType, resultData, initiallyVisible = false) => {
    if (!userId || !activityType || resultData === undefined) { // Check for undefined resultData too
        console.error("User ID, activity type, and result data are required to save activity.");
        // Consider throwing an error or returning a more specific error object if needed
        return null;
    }

    try {
        // The 'resultData' is directly what you want to store in the 'result' column.
        // If activityData in MainPage is, for example, { recipe: recipeObject },
        // then resultData here will be that { recipe: recipeObject }.
        const { data: savedActivity, error } = await supabase
            .from('user_activity')
            .insert([{
                user_id: userId,
                created_at: new Date().toISOString(),
                result: resultData,         // This is the JSONB column holding your specific activity data
                activity_type: activityType,
                visible: initiallyVisible   // Add the visible flag here
            }])
            .select()  // Select all columns of the newly inserted row(s)
            .single(); // Since we are inserting one object, we expect one back

        if (error) {
            console.error('Error saving user activity:', error);
            // You might want to throw the error so the calling function can catch it
            // and display a more user-friendly message.
            throw error;
        }

        console.log('User activity saved:', savedActivity);
        return savedActivity; // Return the full saved activity object, which includes the 'id'

    } catch (err) {
        // Catch any errors, including those re-thrown from the Supabase client
        console.error("Unexpected error in saveUserActivity:", err.message);
        return null; // Or re-throw err;
    }
};


export const deleteUserActivityRecord = async (scanId) => {
    const { error } = await supabase
        .from('user_activity')
        .delete()
        .eq('id', scanId);

    if (error) throw error;
};
